import React from 'react';

import PropTypes from 'prop-types';

import ImageViewer from './image-viewer';

import '../../styles/image-viewer-modal.scss';

const ImageViewerModal = (props) => {
  const { imageSrc, setImageActive } = props;
  const transformWrapperProperties = {
    centerZoomedOut: true,
    wheel: {
      step: 0.5
    }
  };
  const modalCloseToggle = () => {
    setImageActive((prev) => ({
      ...prev,
      isModalOpen: false
    }));
  };
  return (
    <div className="image-viewer-modal-wrapper" role="presentation" onClick={modalCloseToggle}>
      <ImageViewer
        wrapperClassName="referral-wrapper"
        componentClassName="referral-component"
        transformWrapperProperties={transformWrapperProperties}
      >
        <img data-gumlet="false" src={imageSrc} alt="referral details" />
      </ImageViewer>
    </div>
  );
};

export default ImageViewerModal;

ImageViewerModal.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  setImageActive: PropTypes.func.isRequired
};
